(function($) {
    $(function() {
        var jcarousel = $('.jcarousel-thumbnailsandzoom');

        jcarousel
            .on('jcarousel:reload jcarousel:create', function () {
                var width = jcarousel.innerWidth();

                if (width >= 629) {
                    width = width / 1;
					
                } else if (width >= 628) {
                    width = width / 1;
                }

                jcarousel.jcarousel('items').css('width', width + 'px');
            })
        .jcarousel({
                wrap: 'circular'
            });
			
				

        $('.jcarousel-wrapper-thumbnailsandzoom .jcarousel-control-prev')
            .jcarouselControl({
                target: '-=1'
            });

        $('.jcarousel-wrapper-thumbnailsandzoom .jcarousel-control-next')
            .jcarouselControl({
                target: '+=1'
            });
	
	    $('.jcarousel-thumbnailsandzoom').jcarouselAutoscroll({
        target: '+=1'
        });
       
	   $('.jcarousel-thumbnailsandzoom').jcarouselAutoscroll('reload', {
        interval: 4500
       });
        
		 $('.jcarousel-thumbnailsandzoom').hover(function() {
			$('.jcarousel-thumbnailsandzoom').jcarouselAutoscroll('stop'); 
		 }, function() {
			 $('.jcarousel-thumbnailsandzoom').jcarouselAutoscroll('start');
		 });
		 

  
        $('.jcarousel-wrapper-thumbnailsandzoom .jcarousel-pagination')
            .on('jcarouselpagination:active', 'a', function() {
                $(this).addClass('active');
            })
            .on('jcarouselpagination:inactive', 'a', function() {
                $(this).removeClass('active');
            })
            .on('click', function(e) {
                e.preventDefault();
            })
            .jcarouselPagination({
                perPage: 1,
                item: function(page, carouselItems) {
				//return '<li style="display:none;" class="' + (page == 1 ? "active" : "") + '">' + carouselItems.get() + '</li>';
                return  carouselItems.children('a').clone().attr('href','#').attr('class','').get();
                }
            });
    });
})(jQuery);